<template>
  <span>
    <svg
      :width="width"
      :height="height"
      :strokeWidth="strokeWidth"
      :style="{minWidth:width, alignSelf:vertical, strokeWidth: strokeWidth}"
      class="icon"
    >
      <use v-bind="{ 'xlink:href':'/feather-sprite.svg#'+name }"></use>
    </svg>
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    name,
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    },
    vertical: {
      type: [String],
      default: 'center'
    },
    strokeWidth: {
      type: [Number, String],
      default: 1.5
    }
  }
}
</script>

 <style>
.icon-wrapper {
  display: flex;
  align-items: center;
}

svg {
  align-self: start;
}
.icon {
  stroke: rgb(0, 0, 0);
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  margin-right: 6px;
}
</style>
